import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'form-control-errors',
  templateUrl: './form-control-errors.component.html',
  styleUrls: ['./form-control-errors.component.scss']
})
export class FormControlErrorsComponent implements OnInit {

  @Input() erros: any = null;
  @Input() campo: string = '';

  errosForm: string[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.erros)
      this.errosForm = Object.keys(this.erros);
  }

  ngOnChanges(): void {
    if (this.erros)
      this.errosForm = Object.keys(this.erros);
  }

}
